class LazyShopLogin extends HTMLElement {
  #trigger;
  #abortController;

  connectedCallback() {
    const accountSurface = this.closest('anchored-popover-component, dialog-component');
    this.#trigger = accountSurface?.querySelector('[ref="trigger"]');
    this.#abortController = new AbortController();

    for (const eventName of ['pointerenter', 'pointerdown', 'focusin', 'click']) {
      this.#trigger?.addEventListener(eventName, this.#hydrate, {
        once: true,
        signal: this.#abortController.signal,
      });
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #hydrate = () => {
    const template = this.querySelector('template');
    if (!(template instanceof HTMLTemplateElement)) return;

    this.append(template.content.cloneNode(true));
    template.remove();
    this.#abortController?.abort();
  };
}

if (!customElements.get('lazy-shop-login')) {
  customElements.define('lazy-shop-login', LazyShopLogin);
}
